<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div class="w3-top" style="z-index: 4">
      <div class="w3-bar primary top-bar top-bar-home">
        <button @click="$router.go(-1)" v-show="voltar" class="w3-button w3-small" style="padding-top: 10px"><i class="fa fa-chevron-left"></i> Voltar</button>
        <button @click="$router.push('/admin')" v-show="back" class="w3-button w3-small" style="padding-top: 10px"><i class="fa fa-chevron-left"></i> Voltar</button>
        <button @click="$router.push(backto)" v-show="backto" class="w3-button w3-small" style="padding-top: 10px"><i class="fa fa-chevron-left"></i> Voltar</button>
        <router-link to="/admin" class="w3-bar-item top-bar-title w3-small" v-show="!voltar && !back && !backto" style="padding-top: 10px">Market</router-link>
        <div class="w3-right" v-show="paginaAtual !== 'Login'">
          <div class="w3-bar-item top-bar-icon" style="position: relative; padding: 8px 16px;">
            <a href="javascript:" @click="buscarNotificacoes(true)" :title="(notificacoes.nao_visualizada) === 0 ? 'Você não tem notificações!' : 'Você tem ' + notificacoes.nao_visualizada + ' notificação'">
              <i class="fa fa-bell-o ico-notificacao"></i>
              <span class="w3-red w3-round w3-tiny n-notificacao" v-show="parseInt(notificacoes.nao_visualizada) > 0">{{notificacoes.nao_visualizada}}</span>
            </a>
          </div>
          <button class="w3-bar-item w3-button w3-hide-large w3-hover-none w3-hover-text-light-grey" @click="w3_open"><i class="fa fa-bars ico-notificacao"></i></button>
        </div>
      </div>
    </div>

    <nav class="w3-sidebar w3-collapse w3-white" :class="{'fullscreen' : fullscreen}" style="z-index:3;width:300px;padding-bottom: 30px" id="mySidebar"><br>
      <div class="w3-container w3-bar w3-small">
        <div class="w3-cell-row">
          <div class="w3-cell w3-cell-middle">
            <div>
              <div>Nome</div>
              <strong>{{usuario.nome}}</strong>
            </div>
            <div class="w3-margin-top">
              <div>Email</div>
              <strong>{{usuario.email}}</strong>
            </div>
          </div>
          <div class="w3-cell w3-cell-middle w3-center" style="width: 60px">
            <button class="w3-button w3-round" @click="modaluser = true">
              <i class="fa fa-edit"></i>
              <span class="w3-tiny">Editar</span>
            </button>
          </div>
        </div>
      </div>
      <hr>
      <div class="w3-bar-block">
        <a href="javascript:" @click="$router.push('/admin')" class="w3-bar-item w3-button row-menu">
          <i class="fa fa-home fa-fw"></i>
          &nbsp;Home
        </a>
        <router-link to="/admin/pdv" class="w3-bar-item w3-button row-menu" active-class="primary">
          <i class="fa fa-shopping-bag fa-fw"></i>
          &nbsp;Comprar
        </router-link>
        <router-link to="/admin/minhas-compras" class="w3-bar-item w3-button row-menu" active-class="primary">
          <i class="fa fa-shopping-basket fa-fw"></i>
          &nbsp;Minhas compras
        </router-link>
        <a :href="relProdutos" target="_blank" class="w3-bar-item w3-button row-menu"><i class="fa fa-print fa-fw"></i> &nbsp; Relatórios de Produtos</a>
        <router-link to="/admin/vendas" class="w3-bar-item w3-button row-menu" active-class="primary" v-show="adm"><i class="fa fa-dollar fa-fw"></i> &nbsp; Vendas</router-link>
        <router-link to="/admin/pagamentos" class="w3-bar-item w3-button row-menu" active-class="primary" v-show="adm"><i class="fa fa-money fa-fw"></i> &nbsp; Pagamentos</router-link>
        <router-link to="/admin/produtos" class="w3-bar-item w3-button row-menu" active-class="primary" v-show="adm"><i class="fa fa-th-list fa-fw"></i> &nbsp; Produtos</router-link>
        <router-link to="/admin/colaboradores" class="w3-bar-item w3-button row-menu" active-class="primary" v-show="adm"><i class="fa fa-users fa-fw"></i> &nbsp; Colaboradores</router-link>
        <router-link to="/market/" class="w3-bar-item w3-button row-menu" active-class="primary" v-show="usuario.id_funcao === '3'">
          <i class="fa fa-shopping-cart fa-fw"></i>
          &nbsp;Market
        </router-link>
        <button class="w3-bar-item w3-button row-menu" @click="logoff"><i class="fa fa-sign-out fa-fw"></i> &nbsp; Logout</button>

        <br>
      </div>
    </nav>
    <div class="w3-overlay w3-hide-large w3-animate-opacity" onclick="w3_close()" style="cursor:pointer" title="close side menu" id="myOverlay"></div>

    <div class="w3-modal" :class="{'w3-block': modaluser}" style="padding: 75px 10px">
      <div class="w3-modal-content w3-round w3-small" style="min-height: inherit">
        <div class="primary w3-padding">
          <button class="w3-button w3-right" @click="modaluser = false"><i class="fa fa-times" style="font-size: 1.5em"></i></button>
          <h6 class="w3-small"><b>Meu Usuário</b></h6>
        </div>
        <div class="w3-padding w3-padding-16">
          <div class="w3-row-padding">
            <div class="w3-col m12 w3-margin-top">
              <label><b>Nome</b></label>
              <input class="w3-input w3-border" v-model="dados.nome">
            </div>
            <div class="w3-col m6 w3-margin-top">
              <label><b>Usuario</b></label>
              <input class="w3-input w3-border" v-model="dados.usuario">
            </div>
            <div class="w3-col m6 w3-margin-top">
              <label><b>Email</b></label>
              <input class="w3-input w3-border" v-model="dados.email">
            </div>
            <div class="w3-col m12 w3-margin-top">
              <input id="alterarSenha" type="checkbox" class="w3-check" v-model="alterarSenha">
              <label for="alterarSenha"><b>Alterar Senha</b></label>
            </div>
            <div class="w3-col m6 w3-margin-top">
              <label><b>Senha</b></label>
              <input type="password" class="w3-input w3-border" :class="{'w3-light-gray' : !alterarSenha}" v-model="senha" :disabled="!alterarSenha">
            </div>
            <div class="w3-col m6 w3-margin-top">
              <label><b>Confirmar Senha</b></label>
              <input type="password" class="w3-input w3-border" :class="{'w3-light-gray' : !alterarSenha}"  v-model="confirmarSenha" :disabled="!alterarSenha">
            </div>
            <div></div>
            <div class="w3-col m12 w3-margin-top">
              <label>&nbsp;</label>
              <button class="w3-button w3-block w3-round primary" @click="editarUsuario">Editar</button>
            </div>
          </div>
          <br>
        </div>
      </div>
    </div>

    <div class="w3-modal" :class="{'w3-block': menunotificacao}" style="padding: 75px 10px">
      <div class="w3-modal-content w3-round w3-small" style="min-height: inherit">
        <div class="primary w3-padding">
          <button class="w3-button w3-right" @click="menunotificacao = false"><i class="fa fa-times" style="font-size: 1.5em"></i></button>
          <h6 class="w3-small"><b>Meus Avisos</b></h6>
        </div>
        <div class="w3-display-container" style="height: 50vh; overflow: auto">
          <div class="w3-cell-row w3-padding w3-padding-16 w3-border-bottom" :class="{'w3-light-grey': n.visualizada === '1'}" v-for="n in notificacoes.avisos">
            <div class="w3-cell">
              <div>
                <b>{{n.titulo}}</b> - {{n.horario}}
              </div>
              <span>{{n.mensagem}}</span>
            </div>
          </div>
          <div class="w3-display-middle w3-center" v-show="notificacoes.avisos && notificacoes.avisos.length === 0">
            <i class="fa fa-newspaper-o fa-3x"></i>
            <h6 class="w3-small"><b>Não existem notificações!</b></h6>
          </div>
        </div>
        <div class="w3-padding w3-border">&nbsp;</div>
      </div>
    </div>

  </div>
</template>

<script>
	export default {
      props: {
        voltar: String,
        back: '',
        backto: '',
        fullscreen: String
      },

      data(){
        return{
          token: localStorage.getItem("key"),
          menu: false,
          fa: 'fa-ellipsis-v',
          btnLogoff: false,
          menunotificacao: false,
          modaluser: false,
          notificacoes: [],
          paginaAtual: '',
          adm: false,
          permissoes: [],

          usuario: {
            nome: '',
            usuario: '',
            email: '',
          },

          dados: {
            nome: '',
            usuario: '',
            email: '',
          },

          senha: '',
          confirmarSenha: '',
          alterarSenha: false,
          relProdutos: ''
        }
      },

      methods: {
        w3_open() {
          let mySidebar = document.getElementById("mySidebar");
          let overlayBg = document.getElementById("myOverlay");

          if (mySidebar.style.display === 'block') {
            mySidebar.style.display = 'none';
            overlayBg.style.display = "none";
          } else {
            mySidebar.style.display = 'block';
            overlayBg.style.display = "block";
          }
        },

        validarMenu() {
          //Nao deixando ngm logar
          // localStorage.clear();
          if (!localStorage.getItem('key')) {
            localStorage.clear();
            this.$router.push("/login/");
          }
        },

        getLStorage(item) {
          return localStorage.getItem(item);
        },

        logoff(){
          localStorage.clear();
          sessionStorage.clear();
          this.$router.push("/login");
        },

        visualizarNotificacoes() {
          openLoading("Buscando..");
          this.$http.post(base_url + "notificacao/" + this.token, {}, {emulateJSON: true})
            .then(res => {
              closeLoading();
            }, res => {
              console.log(res);
              closeLoading();
              openModalMsg(res.data.result,res.data.msg);
            });
        },

        buscarNotificacoes(visualizar) {
          this.$http.get(base_url + 'notificacoes/' + this.token)
            .then(response => {
              this.notificacoes = response.data;
              closeLoading();

              if (visualizar) {
                this.notificacoes.nao_visualizada = '0';
                this.menunotificacao = true;
                this.visualizarNotificacoes();
              }

            }, res => {
              closeLoading();
              openModalMsg(res.data.result,res.data.msg);
            });
        },

        editarUsuario() {
          if (this.alterarSenha) {
            if (this.senha.length >= 6) {

              if (this.senha !== this.confirmarSenha) {
                openModalMsg("Atençao!", "A senhas não se coincidem!");
                return;
              }

              this.dados.senha = this.senha;

            } else {
              openModalMsg("Atençao!", "A senha deve conter mais que 6 caracteres!");
              return;
            }
          }

          let url = base_url + "usuarios/editar-user/" + this.token;
          this.$http.post(url, this.dados, {emulateJSON: true})
            .then(res => {
              console.log(res);

              closeLoading();
              Object.assign(this.usuario, this.dados);
              localStorage.setItem("usuario", JSON.stringify(this.usuario));

              openModalMsg("Sucesso!", "Dados editados com sucesso!");
              this.modaluser = false;

              if (this.alterarSenha) {
                this.logoff();
              }

              this.alterarSenha = false;
            },

            res => {
              console.log(res);
              closeLoading();
              openModalMsg(res.data.result ? res.data.result : "Atenção", res.data.msg ? res.data.msg : "Erro interno no servidor!");
            });
        }

      },

      created() {
        if (!localStorage.getItem("key")){
          localStorage.clear();
          this.$router.push("/login")

        } else {
          this.buscarNotificacoes(false);
          this.$parent.$on('buscarNotificacoes', () => {
            this.buscarNotificacoes(false)
          });
        }

        this.relProdutos = base_url + 'relatorios/produtos';
      },

      mounted() {
        this.paginaAtual = this.$router.currentRoute.name;
        this.validarMenu();
        this.adm = this.getLStorage('administrativo') && this.getLStorage('administrativo') === 'true';

        if (this.getLStorage('usuario')) {
          this.usuario = JSON.parse(this.getLStorage('usuario'));
          Object.assign(this.dados, this.usuario);
        }
      }
	}
</script>

<style>
  .top-bar-home{
    padding: 6px 4px;
    margin-bottom: 20px;
  }
  .top-bar-home-sidebar {
    width:40%;
    right:1%;
    top: 52px;
    height:inherit;
    padding: 6px 8px;
  }
  .ico-notificacao{
    font-size: 20px;
  }
  .n-notificacao {
    position: absolute;
    padding: 1px 6px;
    top: 0;
    right: 10px;
  }
  .menu-notificacao {
    position: absolute;
    width: 200px;
    right: 43px;
    top: 43px;
  }
  .row-menu{
    padding: 12px 8px!important
  }
</style>



// WEBPACK FOOTER //
// src/components/commons/TopBar.vue